import React, { useState, useEffect } from "react";
import styled from "styled-components";
import SchoolDistrictActionsLink from "./SchoolDistrictActionsLink";
import SchoolDistrictsListing from "./SchoolDistrictsListing";
import ImportSchoolSheetForm from "./ImportSchoolSheetForm";
import StatsUploadContent from "./StatUploadContent";
import ChangeSchoolContent from "./ChangeSchoolContent";
import MergeOrganizationsContent from "../Other/MergeOrganizationsContent";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5em;
  background: #f8f8f8;
  border-radius: 5px;
  box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.05);
  padding: 1.5em;
  min-height: 400px;
`;

export default function SchoolDistrictContent({ colors }) {
  const [mode, setMode] = useState("list");
  const [toChange, setToChange] = useState(null);
  const current = useSelector((s) => s.auth.selected_subscriptions) || {};
  const location = useLocation();
  const locationMode = location.state?.mode;

  useEffect(() => {
    const nextMode = locationMode || "list";
    setMode(nextMode);
    if (nextMode !== "change") {
      setToChange(null);
    }
  }, [location.key, locationMode]);

  const onChangeClick = (school) => {
    setToChange(school);
    setMode("change");
  };

  // cancel or after complete
  const leaveChange = () => {
    setToChange(null);
    setMode("list");
  };
  return (
    <Container>
      <SchoolDistrictActionsLink
        colors={colors}
        onList={() => setMode("list")}
        onImport={() => setMode("import")}
        onUploads={() => setMode("uploads")}
        onMerge={() => setMode("merge")}
      />

      {mode === "list" && (
        <SchoolDistrictsListing colors={colors} onChange={onChangeClick} />
      )}

      {mode === "import" && (
        <ImportSchoolSheetForm
          colors={colors}
          onCancel={() => setMode("list")}
        />
      )}

      {mode === "uploads" && (
        <StatsUploadContent
          colors={colors}
          onImport={() => setMode("uploads")}
        />
      )}

      {mode === "change" && toChange && (
        <ChangeSchoolContent
          colors={colors}
          invoiceId={current.invoice_id}
          schoolFrom={toChange}
          onCancel={() => setMode("list")}
          onComplete={() => setMode("list")}
        />
      )}

      {mode === "merge" && (
        <MergeOrganizationsContent
          colors={colors}
          onCancel={() => setMode("list")}
        />
      )}
    </Container>
  );
}
